/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type co_getplato_grid_sales_features_draft_filter_FilterRequest = {
    customers: Array<string>;
    users: Array<string>;
    search_query?: string;
    state?: co_getplato_grid_sales_features_draft_filter_FilterRequest.state;
};
export namespace co_getplato_grid_sales_features_draft_filter_FilterRequest {
    export enum state {
        NEW = 'NEW',
        SUBMITTED = 'SUBMITTED',
    }
}

